import { render, staticRenderFns } from "./FaqsAdd.vue?vue&type=template&id=df583226&scoped=true&"
import script from "./FaqsAdd.vue?vue&type=script&lang=js&"
export * from "./FaqsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df583226",
  null
  
)

export default component.exports